module.exports = __webpack_public_path__ + "media/public/img/landing_page/where-travel-web-8dab6f4ee2d130db73e5ad1703176e30.png";